import { render, staticRenderFns } from "./StudentMerger.vue?vue&type=template&id=76683a8a&"
import script from "./StudentMerger.vue?vue&type=script&lang=js&"
export * from "./StudentMerger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports